import HeadlessHostedInputGetOptions from "../../../../content/sdk/web/2.x.x/primer-headless-checkout/_headlessHostedInput/headlessHostedInputGetOptions.mdx";
import HeadlessHostedInputSetOptions from "../../../../content/sdk/web/2.x.x/primer-headless-checkout/_headlessHostedInput/headlessHostedInputSetOptions.mdx";
import HeadlessHostedInputRender from "../../../../content/sdk/web/2.x.x/primer-headless-checkout/_headlessHostedInput/headlessHostedInputRender.mdx";
import * as React from 'react';
export default {
  HeadlessHostedInputGetOptions,
  HeadlessHostedInputSetOptions,
  HeadlessHostedInputRender,
  React
};